import styled from 'styled-components';
import { Typ51, Typ35 } from 'dc/Typ';
import CarNav01 from 'dc/CarNav01';
import Btn021 from 'dc/Btn021';
import Btn30 from 'dc/Btn30';

const colors = {
  dark: {
    background: 'linear-gradient(110.12deg, #007079 0%, #35b8c4 100%)',
    text: '#fff',
    navigationButtons: {
      mainColor: '#fff',
      hoverColor: '#007079',
    },
  },
  light: {
    background: 'linear-gradient(110.12deg, #CDF2F7 0%, #FFFFFF 100%)',
    text: '#16356C',
    navigationButtons: {
      mainColor: '#007079',
      hoverColor: '#fff',
    },
  },
};

type ContainerProps = {
  theme: string;
};

export const Container = styled.div<ContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 568px;
  background: ${props => colors[props.theme].background};
  box-shadow:
    0px 19px 60px rgba(0, 0, 0, 0.3),
    0px 15px 20px rgba(0, 0, 0, 0.22);
  border-radius: 5px;
`;

export const Wrapper = styled.div`
  padding: 56px 0 29px;
  width: 320px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  z-index: 1;
`;

export const TopWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

type TitleProps = {
  theme: string;
};

export const Title = styled(Typ51)<TitleProps>`
  width: 288px;
  color: ${props => colors[props.theme].text};
  margin-bottom: 12px;
`;

type TextProps = {
  theme: string;
};

export const Text = styled(Typ35)<TextProps>`
  width: 240px;
  color: ${props => colors[props.theme].text};
  margin-bottom: 2px;
  line-height: 19px;
  span {
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
    color: inherit;
  }
  span:first-of-type {
    padding: 0;
  }
`;

export const ImageWrapper = styled.div`
  width: 320px;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img``;

export const CarouselDots = styled(CarNav01)`
  margin-bottom: 6px;
`;

export const Button = styled(Btn021)`
  width: 288px;
`;

export const ButtonSpace = styled.div`
  width: 288px;
  height: 36px;
`;

export const BottomBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px 20px 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

type NavigationButtonProps = {
  hidden: boolean;
  theme: string;
};

export const NavigationButton = styled(Btn30)<NavigationButtonProps>`
  visibility: ${props => (props.hidden ? 'hidden' : 'visible')};
  cursor: ${props => (props.hidden ? 'default' : 'pointer')};
  background-color: transparent;
  border-color: ${props => colors[props.theme].navigationButtons.mainColor};
  i {
    color: ${props => colors[props.theme].navigationButtons.mainColor};
  }

  &:hover {
    background-color: ${props =>
      colors[props.theme].navigationButtons.mainColor};
    border-color: ${props => colors[props.theme].navigationButtons.mainColor};
  }
  &:hover i {
    color: ${props => colors[props.theme].navigationButtons.hoverColor};
  }
`;
